/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * @file AppContext.tsx
 * Exports a higher order provider component for wrapping the entire app.
 *
 * Children of this provider component have accessed to the shared values stored
 * in appState and the dispatchers stored in appAction.
 */
import React, { useReducer } from 'react';
import { appReducer } from './appReducer';
import { getAppContextInit, AppContext } from './AppContext';

/**
 * AppProvider component.
 *
 * Children of this provider component have accessed to the shared values stored
 * in appState and the dispatchers stored in appAction.
 *
 * When the provider is first created, the appState is initialized with data
 * stored in an external JSON file. The source prop specifies which data source
 * to use for this instances of the selector tool (database or iaas).
 *
 * @param {object} props Component props
 * @param {string} props.source The apps source data file; database or iaas.
 * @param {Node} props.children Form submit callback function
 */

type Props = {
  source: string;
  children?: React.ReactNode;
};

const AppProvider: React.FC<Props> = ({ source, children }) => {
  const [appState, appAction] = useReducer(
    appReducer,
    getAppContextInit(source),
  );
  return (
    <AppContext.Provider value={{ appState, appAction }}>
      {children}
    </AppContext.Provider>
  );
};
export default AppProvider;
